import script from "./hct-search.vue?vue&type=script&setup=true&lang=js"
export * from "./hct-search.vue?vue&type=script&setup=true&lang=js"

import "./hct-search.vue?vue&type=style&index=0&id=bf6f34f6&scoped=true&lang=scss"

import exportComponent from "E:\\a-project\\hct-element\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf6f34f6"]])

export default __exports__